// unauthorized-redirect.guard.ts
import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AnswersApiService } from '../services/answers-api.service';
import { GlobalStore } from '../store/global-store';

@Injectable({ providedIn: 'root' })
export class UnauthorizedRedirectGuard implements CanActivate {

  #globalStore =inject(GlobalStore)
  constructor(
    private router: Router,
    private api: AnswersApiService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const id = Number(route.paramMap.get('id'));
    const unauthorized = route.queryParamMap.get('unauthorized') === 'true';

    if (!unauthorized || !id) return true;

   return this.api.addUnauthorizedUrl(id).pipe(
    map(res => {
      const path = res.startsWith('/') ? res : `/${res}`;
      this.#globalStore.refreshQuestionnaireAfterUpdate()
      return this.router.parseUrl(path); // עוצר שרשרת ולא מריץ גארדים נוספים
    }),
    catchError(() => 
      {
        
        return of(this.router.parseUrl('/'))
      }
      )
  );
  }
}
